module.exports = __webpack_public_path__ + "static/media/select-amulet.6c281499.mp3";